export default "__VITE_ASSET__BvwwToiC__"